import axios from 'axios'
import { FirebaseDocRefType, auth, db } from 'firebase/index'
import { getConverter } from 'lib/firestore'
import { StaffType } from 'types/staff'

const staffConverter = getConverter<StaffType>()

export const fetchStaff = async (uid: string): Promise<StaffType | undefined> => {
  return db
    .collection('staffs')
    .doc(uid)
    .withConverter(staffConverter)
    .get()
    .then((snapshot) => {
      return snapshot.data()
    })
    .catch((error) => {
      console.error(error)
      return undefined
    })
}

export const fetchBrandStaffs = async (brandRef: FirebaseDocRefType) => {
  const staffs = await db
    .collection('staffs')
    .withConverter(staffConverter)
    .get()
    .then((snapshots) => snapshots.docs.map((snapshot) => snapshot.data()))
  return staffs.filter((staff) => staff.roles.some((role) => role.brand_ref?.id === brandRef.id))
}

export const fetchStoreStaffs = async (storeRef: FirebaseDocRefType) => {
  const staffs = await db
    .collection('staffs')
    .withConverter(staffConverter)
    .get()
    .then((snapshots) => snapshots.docs.map((snapshot) => snapshot.data()))
  return staffs.filter((staff) => staff.roles.some((role) => role.store_ref.id === storeRef.id))
}

export const setStaff = (ref: FirebaseDocRefType, staff: StaffType): Promise<void> => {
  return ref.set(staff, { merge: true })
}

// 店舗の権限（roles）の変更は、Firestore ルールでクライアントからの直接の書き込みを禁じているため Functions の API で行う
export const postStaffApi = async <T = Record<string, unknown>>(
  endpoint: string,
  body: Record<string, unknown>
): Promise<T> => {
  const token = await auth.currentUser?.getIdToken()
  if (!token) throw new Error('認証トークンの取得に失敗しました。')
  const response = await axios.post<T>(endpoint, body, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  })
  return response.data
}

// postStaffApi の失敗を、利用者に見せるメッセージにする（API が理由を返していればそれを添える）
export const toStaffApiErrorMessage = (error: unknown, fallback: string): string => {
  const reason = axios.isAxiosError(error)
    ? error.response?.data?.message ?? error.response?.data?.error_message
    : undefined
  return typeof reason === 'string' && reason !== '' ? `${fallback}\n${reason}` : fallback
}
